import ApiService from './api.service';
import { LocalityDTO } from '../models/LocalityDTO';

export default class LocalityService {
  /**
   * Get localities
   *
   * @returns {LocalityDTO[]} a list of LocalityDTO object
   * @throws ApiError
   */
  public static async fetchLocalities(): Promise<LocalityDTO[]> {
    return await ApiService.get(`${process.env.VUE_APP_PUBLIC_ROOT_API}/localities`)
      .then((response: any) => {
        return response.data as LocalityDTO[];
      });
  }
}
